import Base_URL from '../config/apiConfig';
import axiosInstance from './axiosInstance';

/**
 * Calls the backend API to run fuzzy logic on selected entities.
 * @param {string} workflowName - Name of the current workflow.
 * @param {object} entityPayload - Contains selected source/destination entities and config info.
 * @returns {Promise<object>} - The API response.
 */
 

export const runFuzzyLogicAPI = async (payload) => {
  const response = await axiosInstance.post(`${Base_URL}/mapentity`, payload);
  return response.data;
};


export const runFieldMappingAPI = async (payload) => {
  const response = await axiosInstance.post(`${Base_URL}/mapfields`, payload);
  return response.data;
};